/**
 * Форматирует время курса из минут в читаемый формат с округлением к ближайшему часу
 * @param minutes - время в минутах (может быть null)
 * @returns отформатированная строка в формате "~ 2 часа" или пустая строка, если время не указано
 */
export const formatCourseTime = (minutes: number | null): string => {
    if (!minutes || minutes <= 0) {
        return '';
    }

    // Округляем к ближайшему часу
    const hours = Math.round(minutes / 60);

    // Если получился 0 часов после округления, показываем 1 час
    const displayHours = hours === 0 ? 1 : hours;

    // Склонение слова "час"
    const getHourWord = (count: number): string => {
        if (count === 1) {
            return 'час';
        } else if (count >= 2 && count <= 4) {
            return 'часа';
        }

        return 'часов';
    };

    return `~ ${displayHours} ${getHourWord(displayHours)}`;
};
